export default __webpack_public_path__ + "static/media/NOTO_SANS_TC.08671948.ttf";